export abstract class CommonConstants {

    static readonly DEVICES_OS = {
        iOS: 'iOS'
    }

    static readonly DISPLAY_STANDALONE = '(display-mode: standalone)';

}
